import { alpha } from "@mui/material";
import { grey, blue } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    height: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  secondaryContainer: {
    height: "100%",
    display: "flex",
    padding: "0px !important",
    gap: "12px",
    alignItems: "center",
  },
  sectionContainer: {
    height: "100%",
    color: grey[700],
    backgroundColor: alpha(grey[500], 0.15),
    borderRadius: "8px",
    padding: "10px 0px",
  },
  extraSectionContainer: {
    height: "100%",
    color: blue[700],
    backgroundColor: alpha(blue[500], 0.15),
    borderRadius: "8px",
    padding: "10px 0px",
  },
  title: {
    fontWeight: "bold",
  },
  data: {
    fontWeight: "bold",
  },
  rowContainer: {
    display: "flex",
    padding: "0px !important",
    gap: "12px",
  },
};

export default styles;
